// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import SupportPage from "../pages/Support/Support";
const __wvcRoutePaths = ["/SupportPage", "/support"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["contact", "contactpage", "features", "featurespage", "home", "homepage", "post", "support", "supportpage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<SupportPage />} />
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<SupportPage />} />
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
